import { useState } from "react";
import { api } from "../lib/api";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

/**
 * Multi-image uploader. Value = array of { url, file_id } or plain url strings.
 */
export default function ImageUpload({ value = [], onChange, max = 10 }) {
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    if (value.length + files.length > max) {
      toast.error(`Max ${max} images`);
      return;
    }
    setUploading(true);
    const uploaded = [];
    for (const f of files) {
      const form = new FormData();
      form.append("file", f);
      try {
        const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push({ url: data.url, file_id: data.file_id });
      } catch (err) {
        toast.error(`Upload échoué: ${f.name}`);
      }
    }
    onChange?.([...value, ...uploaded]);
    setUploading(false);
    e.target.value = "";
  };

  const remove = (i) => onChange?.(value.filter((_, idx) => idx !== i));

  const getSrc = (item) => {
    const u = typeof item === "string" ? item : item.url;
    if (!u) return "";
    // Prepend backend URL for /api/files/...
    if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
    return u;
  };

  return (
    <div data-testid="image-upload">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {value.map((item, i) => (
          <div key={i} className="relative aspect-[4/3] squircle bg-[#f5f5f7] overflow-hidden group">
            <img src={getSrc(item)} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => remove(i)}
              className="absolute top-2 right-2 bg-white/90 backdrop-blur rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition"
              data-testid={`remove-image-${i}`}
            >
              <X size={14} />
            </button>
          </div>
        ))}
        {value.length < max && (
          <label className="aspect-[4/3] rounded-2xl border-2 border-dashed border-black/10 bg-[#fafafa] hover:bg-[#f5f5f7] flex flex-col items-center justify-center cursor-pointer transition">
            {uploading ? (
              <Loader2 size={20} className="animate-spin text-[#86868b]" />
            ) : (
              <>
                <Upload size={18} strokeWidth={1.5} className="text-[#86868b] mb-2" />
                <span className="text-[12px] text-[#86868b]">Ajouter</span>
              </>
            )}
            <input
              type="file"
              accept="image/*"
              multiple
              className="hidden"
              onChange={handleFiles}
              disabled={uploading}
              data-testid="image-upload-input"
            />
          </label>
        )}
      </div>
      <div className="text-[11px] text-[#86868b] mt-2">
        Max {max} images · jpg, png, webp · 8MB par image
      </div>
    </div>
  );
}
